import script from "./ContainerHomeSocials.vue?vue&type=script&setup=true&lang=js"
export * from "./ContainerHomeSocials.vue?vue&type=script&setup=true&lang=js"

import "./ContainerHomeSocials.vue?vue&type=style&index=0&id=ddbb6bae&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddbb6bae"]])

export default __exports__